/**
 * Created by hao.cheng on 2017/5/7.
 */
import React from 'react';
import styled from "styled-components";
import {CopyToClipboard} from 'react-copy-to-clipboard';

const VContent = styled.div`
    overflow:hidden;
    .helpvideo-item{
      width: 50%;
      float:left;
      >div{
       font-size:14px;
       padding:8px 0 12px;
      }
      a{
        display:block;
      }
      img{
        width:100%
      }
    }
    
    .helpvideo-item:nth-child(2n-1){
     img{
      border-right:2px solid #fff;
     }
    }
    .helpvideo-item:nth-child(2n){
     img{
      border-left:2px solid #fff;
     }
    }

    
`



class HelpVideo extends React.Component {
    state = {
        animated: '',
        data:[
            {title:'摇一摇签到操作指南',url:'http://v.youku.com/v_show/id_XMTg1MTg3MDUwNA==.html?spm=a2hzp.8244740.userfeed.5!2~5~5~5!3~5~A&qq-pf-to=pcqq.group',src:'https://img.qdj8.cn/yaoyiyao.jpg'},
            {title:'3D签到墙演示视频',url:'https://www.bilibili.com/video/av22342147/?spm_id_from=333.23.home_video_list.1',src:'https://img.qdj8.cn/qiandaoqiang.jpg'},
            {title:'PC扫码平台（即插即用）',url:'https://www.bilibili.com/video/av22639586',src:'https://img.qdj8.cn/pcsaoma.jpg'},
            {title:'无线扫码枪',url:'https://www.bilibili.com/video/av23204493/',src:'https://img.qdj8.cn/saomaqiang.jpg'},
            {title:'主办方抽奖',url:'https://www.bilibili.com/video/av23853599',src:'https://img.qdj8.cn/draw.jpg'},
            {title:'参与人摇奖',url:'https://www.bilibili.com/video/av24187436/',src:'https://img.qdj8.cn/bhweel.jpg'},
            {title:'摇一摇推广',src:'https://img.qdj8.cn/helpcover1.jpg',url:'https://www.bilibili.com/video/av28765309/?p=1'},
            {title:'小程序和公众号',src:'https://img.qdj8.cn/helpcover2.jpg',url:'https://www.bilibili.com/video/av28765309/?p=2'},
            {title:'开具发票',src:'https://img.qdj8.cn/helpcover3.jpg',url:'https://www.bilibili.com/video/av28765309/?p=3'},
            {title:'替他人同时报名和购票',src:'https://img.qdj8.cn/helpcover4.jpg',url:'https://www.bilibili.com/video/av28765309/?p=4'},
            {title:'购买会员',src:'https://img.qdj8.cn/helpcover5.jpg',url:'https://www.bilibili.com/video/av28765309/?p=5'},
            {title:'门票销售优惠劵',src:'https://img.qdj8.cn/helpcover6.jpg',url:'https://www.bilibili.com/video/av28765309/?p=6'},
            {title:'唯一字段、去掉手机号',src:'https://img.qdj8.cn/helpcover7.jpg',url:'https://www.bilibili.com/video/av28765309/?p=7'},
            {title:'基础版-会员版-高级会员',src:'https://img.qdj8.cn/helpcover8.jpg',url:'https://www.bilibili.com/video/av28765309/?p=8'},
            {title:'去（换）LOGO服务',src:'https://img.qdj8.cn/helpcover9.jpg',url:'https://www.bilibili.com/video/av28765309/?p=9'},
            {title:'EXCEL导入参与人',src:'https://img.qdj8.cn/helpcover10.jpg',url:'https://www.bilibili.com/video/av28765309/?p=10'},
            {title:'分配管理',src:'https://img.qdj8.cn/helpcover11.jpg',url:'https://www.bilibili.com/video/av28765309/?p=11'},
            {title:'无需报名直接签到',src:'https://img.qdj8.cn/helpcover12.jpg',url:'https://www.bilibili.com/video/av28765309/?p=12'},
            {title:'自定义报名表',src:'https://img.qdj8.cn/helpcover13.jpg',url:'https://www.bilibili.com/video/av28765309/?p=13'},
            {title:'无线扫码枪连接',src:'https://img.qdj8.cn/helpcover14.jpg',url:'https://www.bilibili.com/video/av29258148'},
            {title:'热敏打印机',src:'https://img.qdj8.cn/helpcover15.jpg',url:'https://www.bilibili.com/video/av32100828/?p=1'},

        ],
    };

    render() {
        return (
            <div style={{ background: '#ececec',borderTop:'4px solid #fff',textAlign:'center'}}>

                <VContent>
                    {this.state.data.map((obj,index)=>{
                        return <div key={index} className='helpvideo-item'>
                            <a href={obj.url} target="_Blank">
                                <img src={obj.src} alt=""/>
                            </a>
                            <div>{obj.title}</div>
                        </div>
                    })}


                </VContent>
            </div>
        )
    }
}

export default HelpVideo;


// WEBPACK FOOTER //
// ./src/containers/HelpVideo.jsx